module.exports = __webpack_public_path__ + "static/media/mammacare-symbol.f8d7b0b6.png";